import CustomDialog from "components/CustomDialog";
import React, { useState } from "react";
import ChangeHistory from "./ChangeHistory";
import { useSelector } from "react-redux";
import useQuery from 'hooks/useQuery';

const ChangeHistoryDialog = ({
    isShow = false,
    onConfirm = () => null,
    dataList = null,
}) => {

    const formId = useQuery('id');
    const detail = useSelector((state) => state.applicationDetail);
    const applicationDetail = detail[formId];

    return (
        <CustomDialog
            isShow={isShow}
            onConfirm={() => {
                onConfirm?.();
            }}
            title={dataList?.length > 0 ? "Change History" : ""}
            width={dataList?.length > 0 ? 800 : 400}
            maxWidth="lg"
            confirmText="OK"
            disableCancelButton
        >
            {dataList?.length > 0 &&
                dataList?.map((data, index) => (
                    <div key={index}>
                        <ChangeHistory
                            index={index + 1}
                            data={data}
                            applicationDetail={applicationDetail}
                        />
                    </div>
                ))

            }
            {
                Array.isArray(dataList) && dataList?.length <= 0 &&
                 <div style={{ display: 'flex', justifyContent: 'center', fontSize: '18px', fontWeight: 500 }}>No Change History data.</div>
            }
        </CustomDialog>
    );
};

export default ChangeHistoryDialog;